import { getStepToDisplaySelector, invalidLinkReasonSelector, } from '../../../redux/features/passwordless/passwordlessSlice.js';
import { twoStepTrackingComponentStateSelector } from '../../../redux/core/wrapperContext/wrapperContextSlice.js';
import { useAppSelector } from '../../../redux/hooks.js';
const mapReasonToComponentState = (reason) => {
    const componentStateMapping = {
        generalError: 'passwordlessLinkTryAgain',
        expiredLink: 'passwordlessLinkExpired',
        alreadyBeenUsed: 'passwordlessLinkAlreadyUsed',
    };
    return componentStateMapping[reason || 'generalError'];
};
export const usePasswordlessComponentStateBuilder = () => {
    const invalidLinkReason = useAppSelector(invalidLinkReasonSelector);
    // to discuss because stepToDisplay isn't updated componentState builder returns always undefined
    const stepToDisplay = useAppSelector(getStepToDisplaySelector);
    const componentStateForTwoStep = useAppSelector(twoStepTrackingComponentStateSelector);
    if (stepToDisplay === 'postInvalidLinkConfirmation') {
        return 'passwordlessCheckInboxOneTimeLinkSent';
    }
    if (stepToDisplay === 'invalidLinkForm') {
        return mapReasonToComponentState(invalidLinkReason || 'generalError');
    }
    if (stepToDisplay === 'twoStepLogin' ||
        stepToDisplay === 'twoStepPasswordlessConfirmation') {
        return componentStateForTwoStep;
    }
};
//# sourceMappingURL=usePasswordlessComponentStateBuilder.js.map